/**
 * Gift With Purchase – Auto add/remove gift at threshold
 * Works with Shopify AJAX cart on all plans.
 * Configure the constants below.
 */

(() => {
  // === CONFIG ===
  // Vul OF GIFT_VARIANT_ID in (aanrader) OF GIFT_PRODUCT_HANDLE (dan pakt de eerste beschikbare variant)
  const THRESHOLD_CENTS = 7500; // €75 = 7500 (altijd in centen)
  const GIFT_VARIANT_ID = window.__GIFT_VARIANT_ID || 50295188455762; // jouw variant ID
  const GIFT_PRODUCT_HANDLE = window.__GIFT_PRODUCT_HANDLE || null; // niet gebruikt // bijv. "gratis-hart-hangertje"

  // Hoe vaak we checken na cart-wijzigingen (ms)
  const CHECK_DEBOUNCE = 500;

  // === HELPERS ===
  const getCart = () => fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());

  const getGiftVariantId = async () => {
    if (GIFT_VARIANT_ID) return Number(GIFT_VARIANT_ID);

    if (!GIFT_PRODUCT_HANDLE) return null;
    // Haal product JSON op en kies de eerste beschikbare variant
    const res = await fetch(`/products/${GIFT_PRODUCT_HANDLE}.js`, { credentials: 'same-origin' });
    if (!res.ok) return null;
    const product = await res.json();
    const firstAvailable = product.variants?.find(v => v.available);
    return firstAvailable ? Number(firstAvailable.id) : null;
  };

  const giftLineInCart = (cart, variantId) =>
    cart.items.find(i => i.variant_id === Number(variantId));

  const addGift = async (variantId) => {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: Number(variantId), quantity: 1, properties: { _free_gift: 'true' } })
    }).then(r => r.json()).catch(() => null);
  };

  const removeGift = async (line) => {
    // /cart/change.js supports either line index (1-based) or key.
    // We’ll use the line index to be theme-agnostic; derive it by re-reading the cart.
    const cart = await getCart();
    const idx = cart.items.findIndex(i => i.key === line.key);
    if (idx === -1) return null;

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: idx + 1, quantity: 0 })
    }).then(r => r.json()).catch(() => null);
  };

  let checkTimer = null;
  const scheduleCheck = () => {
    clearTimeout(checkTimer);
    checkTimer = setTimeout(runCheck, CHECK_DEBOUNCE);
  };

  // Probeer te hooken op fetch-calls die de cart wijzigen om real-time te reageren
  const originalFetch = window.fetch;
  window.fetch = async function patchedFetch(input, init) {
    const res = await originalFetch(input, init);
    try {
      const url = typeof input === 'string' ? input : (input?.url || '');
      if (/(\/cart\/add\.js|\/cart\/change\.js|\/cart\/update\.js|\/cart\/clear\.js)$/i.test(url)) {
        scheduleCheck();
      }
    } catch (e) {}
    return res;
  };

  async function runCheck() {
    try {
      const variantId = await getGiftVariantId();
      if (!variantId) return;

      const cart = await getCart();
      const subtotal = cart.items_subtotal_price; // in centen
      const giftLine = giftLineInCart(cart, variantId);

      if (subtotal >= THRESHOLD_CENTS) {
        // Voeg gift toe als die er nog niet is
        if (!giftLine) await addGift(variantId);
      } else {
        // Verwijder gift als die er is
        if (giftLine) await removeGift(giftLine);
      }

      // (Optioneel) trigger een custom event zodat je theme/cart drawer kan refreshen
      document.dispatchEvent(new CustomEvent('gift:checked'));
    } catch (e) {
      // Fail silently to avoid blocking checkout
      console.warn('[GWP] Error:', e);
    }
  }

  // Init
  document.addEventListener('DOMContentLoaded', runCheck);
  // Fallback: check na 1s en 3s (voor thema’s die eigen cart-events hebben)
  setTimeout(runCheck, 1000);
  setTimeout(runCheck, 3000);
})();
